/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import DeclarationList from "./DeclarationList";

export default DeclarationList;
